"use client"

import { Pressable } from "react-native"
import { styled } from "nativewind"

export const PressableBox = styled(Pressable, "cursor-pointer")
